import subtypesJson from "./subtypes.json";

// subtypes.json is the single source of truth for the closed creature
// Race / Class enums, mirrored by RACES / CLASSES in
// card-engine/src/cards.rs (a parity test keeps them aligned). The same
// file is read by the card-gen Python pipeline.
const RAW = subtypesJson as {
  races: string[];
  classes: string[];
  faction_default_race: Record<string, string>;
};

/** All creature races, in `subtypes.json` order. */
export const RACES: readonly string[] = RAW.races;

/** All creature classes, in `subtypes.json` order. */
export const CLASSES: readonly string[] = RAW.classes;

/** The race a faction's creatures default to, keyed by faction id. */
export const FACTION_DEFAULT_RACE: Readonly<Record<string, string>> =
  RAW.faction_default_race;
